const emojisObj = {}
emojisObj.emojis = [
  '😀',
  '😃',
  '😄',
  '😁',
  '😆',
  '😅',
  '🤣',
  '😂',
  '🙂',
  '🙃',
  '😉',
  '😊',
  '😇',
  '😍',
  '🤩',
  '😘',
  '😗',
  '😚',
  '😙',
  '😋',
  '😛',
  '😜',
  '🤪',
  '😝',
  '🤑',
  '🤗',
  '🤭',
  '🤫',
  '🤔',
  '🤐',
  '🤨',
  '😐',
  '😑',
  '😶',
  '😏',
  '😒',
  '🙄',
  '😬',
  '🤥',
  '😌',
  '😔',
  '😪',
  '🤤',
  '😴',
  '😷',
  '🤒',
  '🤕',
  '🤢',
  '🤮',
  '🤧',
  '😵',
  '🤯',
  '🤠',
  '😎',
  '🤓',
  '🧐',
  '😕',
  '😟',
  '🙁',
  '😮',
  '😯',
  '😲',
  '😳',
  '😦',
  '😧',
  '😨',
  '😰',
  '😥',
  '😢',
  '😭',
  '😱',
  '😖',
  '😣',
  '😞',
  '😓',
  '😩',
  '😫',
  '😤',
  '😡',
  '😠',
  '🤬',
  '😈',
  '👿',
  '💀',
  '💩',
  '🤡',
  '👹',
  '👺',
  '👻',
  '👽',
  '👾',
  '🤖',
  '😺',
  '😸',
  '😹',
  '😻',
  '😼',
  '😽',
  '🙀',
  '😿',
  '😾',
  '💋',
  '👋',
  '🤚',
  '🖐',
  '✋',
  '🖖',
  '👌',
  '🤞',
  '🤟',
  '🤘',
  '🤙',
  '👈',
  '👉',
  '👆',
  '🖕',
  '👇',
  '👍',
  '👎',
  '✊',
  '👊',
  '🤛',
  '🤜',
  '👏',
  '🙌',
  '👐',
  '🤲',
  '🤝',
  '🙏',
  '💅',
  '🤳',
  '💪',
  '👂',
  '👃',
  '🧠',
  '👀',
  '👁',
  '👅',
  '👄',
  '👶',
  '🧒',
  '👦',
  '👧',
  '🧑',
  '👱',
  '👨',
  '🧔',
  '👱‍',
  '👨‍',
  '👨‍',
  '👩',
  '👱‍',
  '👩‍',
  '👩‍',
  '👩‍',
  '👩‍',
  '🧓',
  '👴',
  '👵',
  '🙍',
  '🙅',
  '🙆',
  '💁',
  '🙋',
  '🙇',
  '🙇‍',
  '🙇‍',
  '🤦',
  '🤷',
  '🤷‍',
  '🤷‍',
  '👨‍⚕️',
  '👩‍⚕️',
  '👨‍🎓',
  '👩‍🎓',
  '👨‍🏫',
  '👩‍🏫',
  '👨‍⚖️',
  '👩‍⚖️',
  '👨‍🌾',
  '👩‍🌾',
  '👨‍🍳',
  '👩‍🍳',
  '👨‍🔧',
  '👩‍🔧',
  '👨‍🏭',
  '👩‍🏭',
  '👨‍💼',
  '👩‍💼',
  '👨‍🔬',
  '👩‍🔬',
  '👨‍💻',
  '👩‍💻',
  '👨‍🎤',
  '👩‍🎤',
  '👨‍🎨',
  '👩‍🎨',
  '👨‍✈️',
  '👩‍✈️',
  '👨‍🚀',
  '👩‍🚀',
  '👨‍🚒',
  '👩‍🚒',
  '👮',
  '👮‍♂️',
  '👮‍♀️',
  '🕵',
  '🕵️‍♂️',
  '🕵️‍♀️',
  '💂',
  '💂‍',
  '💂‍',
  '👷',
  '👷‍',
  '👷‍',
  '🤴',
  '👸',
  '👳',
  '👳‍',
  '👳‍',
  '👲',
  '🧕',
  '🤵',
  '👰',
  '🤰',
  '🤱',
  '👼',
  '🎅',
  '🤶',
  '🧙',
  '🧚',
  '🧛',
  '🧜',
  '🧝',
  '🧞',
  '🧟',
  '💆',
  '💇',
  '🚶',
  '🏃',
  '💃',
  '🕺',
  '🕴',
  '👯',
  '🧖',
  '🧖‍',
  '🧖‍',
  '🧘',
  '👭',
  '👫',
  '👬',
  '💏',
  '👨‍',
  '👩‍',
  '💑',
  '👨‍',
  '👩‍',
  '👪',
  '👨‍👩‍👦',
  '👨‍👩‍👧',
  '👨‍👩‍👧‍👦',
  '👨‍👩‍👦‍👦',
  '👨‍👩‍👧‍👧',
  '👨‍👨‍👦',
  '👨‍👨‍👧',
  '👨‍👨‍👧‍👦',
  '👩‍👩‍👦',
  '👩‍👩‍👧',
  '👩‍👩‍👧‍👦',
  '👩‍👩‍👦‍👦',
  '👩‍👩‍👧‍👧',
  '👨‍👦',
  '👨‍👦‍👦',
  '👨‍👧',
  '👨‍👧‍👦',
  '👨‍👧‍👧',
  '👩‍👦',
  '👩‍👦‍👦',
  '👩‍👧',
  '👩‍👧‍👦',
  '👩‍👧‍👧',
  '🗣',
  '👤',
  '👥',
  '👣',
  '🌂',
  '☂',
  '👓',
  '🕶',
  '👔',
  '👕',
  '👖',
  '🧣',
  '🧤',
  '🧥',
  '🧦',
  '👗',
  '👘',
  '👙',
  '👚',
  '👛',
  '👜',
  '👝',
  '🎒',
  '👞',
  '👟',
  '👠',
  '👡',
  '👢',
  '👑',
  '👒',
  '🎩',
  '🎓',
  '🧢',
  '⛑',
  '💄',
  '💍',
  '💼'
]
export default emojisObj



// WEBPACK FOOTER //
// ./src/script/emoji.js